export default function insertScript(scriptText) {
  const script = document.createElement('script');
  script.innerHTML = scriptText;
  document.head.appendChild(script);
}
